import React, { Fragment, useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom'
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import { fetchCaseFull, fetchRelatedCases, default as fallbackProjects } from '../../api/projects';
import ContactForm from '../ServiceSinglePage/ServiceFrom ';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar'
import ImageWithGoogleDrive from '../../components/ImageWithGoogleDrive/ImageWithGoogleDrive';
import logo from '../../images/logo.png'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const ProjectSingle = (props) => {
    const { slug } = useParams();
    const [projectSingle, setProjectSingle] = useState(null);
    const [relatedCases, setRelatedCases] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadProjectSingle = async () => {
            try {
                setLoading(true);

                const caseId = slug.replace('case-', '');
                
                if (caseId && !isNaN(caseId)) {
                    // Load both the main case and related cases
                    const [fullCase, relatedCasesData] = await Promise.all([
                        fetchCaseFull(caseId),
                        fetchRelatedCases(caseId)
                    ]);
                    
                    if (fullCase) {
                        setProjectSingle(fullCase);
                        setRelatedCases(relatedCasesData);
                    } else {
                        // Fallback to static data if API returns null
                        const fallbackCase = fallbackProjects.find(item => item.slug === slug);
                        if (fallbackCase) {
                            setProjectSingle(fallbackCase);
                            setRelatedCases(fallbackProjects.slice(0, 3));
                        }
                    }
                } else {
                    // Try to find in fallback data
                    const fallbackCase = fallbackProjects.find(item => item.slug === slug);
                    if (fallbackCase) {
                        setProjectSingle(fallbackCase);
                        setRelatedCases(fallbackProjects.slice(0, 3));
                    }
                }
            } catch (err) {
                console.error('Error loading project single:', err);
                
                // Fallback to static data on error
                const fallbackCase = fallbackProjects.find(item => item.slug === slug);
                if (fallbackCase) {
                    setProjectSingle(fallbackCase);
                    setRelatedCases(fallbackProjects.slice(0, 3));
                }
            } finally {
                setLoading(false);
            }
        };

        loadProjectSingle();
    }, [slug]);

    // Show loading while API is responding
    if (loading) {
        return (
            <Fragment>
                <Navbar Logo={logo} hclass={"wpo-site-header wpo-site-header-s2"} />
                <PageTitle pageTitle={"Cargando..."} pagesub={"Portfolio"} />
                <section className="project_single section-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 text-center">
                                <div className="loading-spinner">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Cargando...</span>
                                    </div>
                                    <p className="mt-3">Cargando caso...</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer hclass={"wpo-site-footer_s2"} />
                <Scrollbar />
            </Fragment>
        );
    }

    // Always show content - either from API or fallback
    const displayData = projectSingle || fallbackProjects.find(item => item.slug === slug);

    if (!displayData) {
        return (
            <Fragment>
                <Navbar Logo={logo} hclass={"wpo-site-header wpo-site-header-s2"} />
                <PageTitle pageTitle={"Caso no encontrado"} pagesub={"Portfolio"} />
                <section className="project_single section-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 text-center">
                                <p>El caso solicitado no fue encontrado</p>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer hclass={"wpo-site-footer_s2"} />
                <Scrollbar />
            </Fragment>
        );
    }

    return (
        <Fragment>
            <Navbar Logo={logo} hclass={"wpo-site-header wpo-site-header-s2"} />
            <PageTitle pageTitle={displayData.title} pagesub={"Portfolio"} />
            <section className="project_single section-padding">
                <div className="container">
                    {displayData.pSimg ? (
                        <ImageWithGoogleDrive 
                            src={displayData.pSimg} 
                            alt={displayData.title}
                        />
                    ) : null}
                    <div className="row">
                        <div className="col-lg-7 col-12">
                            <h2>{displayData.title}</h2>
                            <div dangerouslySetInnerHTML={{ __html: displayData.docomunt }} />
                        </div>
                        <div className="col-lg-5 col-12">
                            <table>
                                <tbody>
                                    <tr>
                                        <th>Caso :</th>
                                        <td>{displayData.originalData?.name || displayData.subtitle}</td>
                                    </tr>
                                    <tr>
                                        <th>Categoria:</th>
                                        <td>{displayData.subtitle}</td>
                                    </tr>
                                    <tr>
                                        <th>Tiempo :</th>
                                        <td>{displayData.location}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-12 strategies s2">
                            <h2>Beneficios</h2>
                            {console.log('Rendering benefits with data:', displayData?.benefits)}
                            <ul>
                                {displayData.benefits && displayData.benefits.length > 0 ? (
                                    displayData.benefits.map((benefit, index) => (
                                        <li key={benefit.id || index}>
                                            {benefit.title}
                                        </li>
                                    ))
                                ) : (
                                    <>
                                        <li>
                                            Precisión Superior: Permite esculpir el hueso nasal con una
                                            exactitud milimétrica, logrando resultados estéticos más
                                            predecibles y armoniosos.
                                        </li>
                                        <li>
                                            Menor Trauma Tisular: Minimiza el daño a los vasos
                                            sanguíneos y tejidos blandos circundantes, reduciendo el
                                            sangrado durante la cirugía.
                                        </li>
                                        <li>
                                            Recuperación acelerada: Los pacientes experimentan
                                            significativamente menos hinchazón y hematomas, lo que
                                            facilita un postoperatorio más cómodo y una vuelta más
                                            rápida a la rutina.
                                        </li>
                                        <li>
                                            Resultados naturales: Al permitir una remodelación ósea tan
                                            precisa, se consiguen contornos nasales suaves y definidos
                                            que se integran perfectamente con las facciones del rostro,
                                            evitando un aspecto artificial.
                                        </li>
                                    </>
                                )}
                            </ul>
                        </div>
                        <div className="col-lg-6 col-12 strategies s2">
                            <h2>Cuidados Post Operatorios</h2>
                            {console.log('Rendering postOps with data:', displayData?.postOps)}
                            <ul>
                                {displayData.postOps && displayData.postOps.length > 0 ? (
                                    displayData.postOps.map((postOp, index) => (
                                        <li key={postOp.id || index}>
                                            {postOp.title}
                                        </li>
                                    ))
                                ) : (
                                    <>
                                        <li>
                                            Tener una higiene nasal suave: Sigue las indicaciones de tu
                                            cirujano para realizar lavados nasales con suero fisiológico
                                            y evita sonarte la nariz con fuerza durante varias semanas.
                                        </li>
                                        <li>
                                            Evitar esfuerzos y presiones: No hagas ejercicio intenso,
                                            levantes objetos pesados o uses lentes que presionen el
                                            puente nasal por el tiempo que te indique tu médico, y
                                            protege tu nariz del sol directo.
                                        </li>
                                        <li>
                                            Aplicar frío local con cuidado: Durante las primeras 48-72
                                            horas, aplica compresas frías en las mejillas y alrededor de
                                            los ojos, nunca directamente sobre la nariz o la férula.
                                        </li>
                                    </>
                                )}
                            </ul>
                        </div>
                    </div>
                    <div className="related_project">
                        <h5>Cirugías similares</h5>
                        <div className="row">
                            {relatedCases.length > 0 ? (
                                relatedCases.map((project, pitem) => (
                                    <div className="col-lg-4 col-md-6 col-12" key={pitem}>
                                        <div className="project_card">
                                            {project.pimg1 ? (
                                                <ImageWithGoogleDrive 
                                                    src={project.pimg1} 
                                                    alt={project.title}
                                                />
                                            ) : null}
                                            <div className="text">
                                                <h2>
                                                    <Link
                                                        onClick={ClickHandler}
                                                        to={`/project-single/${project.slug}`}
                                                    >
                                                        {project.title}
                                                    </Link>
                                                </h2>
                                                <span>{project.subtitle}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                // Fallback to static data if no related cases from API
                                fallbackProjects.slice(0, 3).map((project, pitem) => (
                                    <div className="col-lg-4 col-md-6 col-12" key={pitem}>
                                        <div className="project_card">
                                            {project.pimg1 ? (
                                                <ImageWithGoogleDrive 
                                                    src={project.pimg1} 
                                                    alt={project.title}
                                                />
                                            ) : null}
                                            <div className="text">
                                                <h2>
                                                    <Link
                                                        onClick={ClickHandler}
                                                        to={`/project-single/${project.slug}`}
                                                    >
                                                        {project.title}
                                                    </Link>
                                                </h2>
                                                <span>{project.subtitle}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </div>
                <div className="AppointmentFrom">
                    <div className="container">
                        <div className="cta_form_s2">
                            <div className="title s2">
                                <h3>Haga una consulta</h3>
                                <p>
                                    Póngase en contacto con nosotros para ver cómo podemos ayudarlo con sus
                                    problemas.
                                </p>
                            </div>
                            <ContactForm />
                        </div>
                    </div>
                </div>
            </section>
            <Footer hclass={"wpo-site-footer_s2"} />
            <Scrollbar />
        </Fragment>
    );
};
export default ProjectSingle;
